<!-- <div class="separator">
    <div></div>
    <div class="e-input-group wrap">
        <label for="search">Search</label>
        <input class="e-input" id="search" name="input" type="text" placeholder="Search" />
    </div>
</div> -->
<div *ngIf="isOrg===true" class="separator">
    <button class="add-event-button" style="font-family: Noto Sans" (click)="newEvent()" mat-button>
        <mat-icon>add</mat-icon>
        Add Event
    </button>
</div>

<!-- organisation name -->
<h1>{{name}}</h1>
<div>
    <!-- description -->
    <p class="description" style="font-family: Noto Sans">{{desciption}}</p>
</div>

<h2>Categories</h2>
<ul>
    <li *ngFor="let interest of interests">
        <p>{{interest}}</p>
    </li>
</ul>


<h2>Events:</h2>
<app-events-list></app-events-list>